module.exports = __webpack_public_path__ + "static/media/history1.3a8d0615.jpg";